var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SelectModal", {
    ref: "selectModal",
    attrs: {
      title: _vm.$t("survey.group.surveys"),
      all: _vm.allSurveys,
      selected: _vm.selectedSurveys,
      label: s =>
        _vm.getLocalizedSurveyNameFromSurvey(s, "?", _vm.$i18n.locale),
      emptyText: _vm.$t("general.none"),
      showFooterButtons: true
    },
    on: {
      selected: function($event) {
        return _vm.$emit("selected", _vm.selectedSurveys)
      },
      add: _vm.onAddSurvey,
      remove: _vm.onRemoveSurvey
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }